import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TokenStorageService } from './token-storage.service';
import { LoginRequest } from '../models/login-request.model';
import { JwtResponse } from '../models/jwt-response.model';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private http = inject(HttpClient);
  private tokenStorage = inject(TokenStorageService);
  private router = inject(Router);

  private loginUrl = `${environment.apiUrl}/authenticate`;

  login(credentials: LoginRequest): Observable<JwtResponse> {
    return this.http.post<JwtResponse>(this.loginUrl, credentials).pipe(
      tap(session => this.tokenStorage.saveUserSession(session))
    );
  }

  isLoggedIn(): boolean {
    return this.tokenStorage.getUserSession() !== null;
  }

  logOut(): void {
    this.tokenStorage.signOut();
    this.router.navigate(['/login']);
  }
}
